export default __webpack_public_path__ + "./assets/shishenjing__195e3b42fc7f2c7c1051dda57ea7ee72.png";